import { Route, Routes } from "react-router-dom";

import { CommandLinkLanding } from "components/CommandLinkLanding";
import { MicroReviewContainer } from "components/MicroReview";

import { COMMAND_LINK_LANDING_RELATIVE_URL } from "../../../../constants";
import { VoluntellLogin } from "../../../VoluntellLogin";
import { ConfirmForgotPassword } from "../ConfirmForgotPassword";
import { ExternalInviteSignUpContainer } from "../ExternalInviteSignUp";
import { ForceChangePassword } from "../ForceChangePassword";
import { ForgotPassword } from "../ForgotPassword";
import { Login } from "../Login";
import { MFAChallengeContainer } from "../MFAChallenge";
import { SignUp } from "../SignUp";
import { SignUpSuccess } from "../SignUpSuccess";
import { Verify } from "../Verify";

export function Switcher() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/force-change-password" element={<ForceChangePassword />} />
      <Route path="/mfa-challenge" element={<MFAChallengeContainer />} />
      <Route path="sign-up" element={<SignUp />} />
      <Route
        path="/external-network-sign-up"
        element={<ExternalInviteSignUpContainer signUpRole="CARRIER" />}
      />
      <Route
        path="/carrier-sign-up"
        element={<ExternalInviteSignUpContainer signUpRole="CARRIER" />}
      />
      <Route
        path="/shipper-sign-up"
        element={<ExternalInviteSignUpContainer signUpRole="SHIPPER" />}
      />
      <Route path="/sign-up/success" element={<SignUpSuccess />} />
      <Route path="/verify" element={<Verify />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route
        path="/confirm-forgot-password"
        element={<ConfirmForgotPassword backToLogin />}
      />
      <Route path="/voluntell-login" element={<VoluntellLogin />} />
      <Route path="/activate-account" element={<VoluntellLogin />} />
      <Route
        path="/submit-shipment-micro-review"
        element={<MicroReviewContainer />}
      />
      <Route
        path={COMMAND_LINK_LANDING_RELATIVE_URL}
        element={<CommandLinkLanding />}
      />
      <Route path="*" element={<Login />} />
    </Routes>
  );
}
